import type { ParameterID } from '@flecto/types'

import { api } from '../../../services/api'

/**
 * Delete product photo by ID.
 *
 * @endpoint DELETE /api/saas/me/products/{productId}/photos/{productPhotoId}
 * @scope saas
 * @see https://flecto.dev/api-4724234
 */
export async function deleteProductPhoto(
  productId: ParameterID,
  productPhotoId: ParameterID
): Promise<void> {
  await api.delete(
    `/api/saas/me/products/${productId}/photos/${productPhotoId}`
  )
}
